import React, { Component } from 'react';
import { connect } from 'react-redux';
import OpenBrandProductList from '../../../views/app/common/OpenBrandProductList';
import { appActions } from '../../../store/modules/app';

class OpenBrandProductListContainer extends Component {
  render() {
    return <OpenBrandProductList {...this.props} />;
  }
}

const mapDispatchToProps = {
  toggleModal: appActions.appToggleModal,
};

export default connect(null, mapDispatchToProps)(OpenBrandProductListContainer);
